import { render, staticRenderFns } from "./LeftSecond.vue?vue&type=template&id=2bdc8664&scoped=true"
import script from "./LeftSecond.vue?vue&type=script&lang=js"
export * from "./LeftSecond.vue?vue&type=script&lang=js"
import style0 from "./LeftSecond.vue?vue&type=style&index=0&id=2bdc8664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc8664",
  null
  
)

export default component.exports